import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import CustomButton from "../../../../Component/CustomButton";
import { styles } from "./styles";
import { NavLink } from "react-router-dom";
import TwoValuePieCard from "../../../../Component/Cards/TwoValuePieCard";
import { BrandColors } from "../../../../styles/BrandColors";
import { useTranslation } from "react-i18next";

const PageHeader = (props) => {
  const { classes, totals = {}, canCreate } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.pageHeaderContainer}>
      <Grid container spacing={0}>
        <Grid item xs={9}>
          <Grid container justify="space-between">
            <Grid item xs={4}>
              <TwoValuePieCard
                value1={totals.amlOngoingCount}
                value2={totals.kycOngoingCount}
                hideChart={true}
                totalLabel={t("labels.checks.dashboard.ongoingChecks")}
              />
            </Grid>
            <Grid item xs={4}>
              <TwoValuePieCard
                value1={totals.amlAssignedToMeCount}
                value2={totals.kycAssignedToMeCount}
                hideChart={true}
                valueColor={BrandColors.JLLBrandColors.Red.core}
                totalLabel={t("labels.checks.dashboard.assignedToMeCaps")}
              />
            </Grid>
            <Grid item xs={4}>
              <TwoValuePieCard
                value1={totals.amlCountryCount}
                value2={totals.kycCountryCount}
                hideChart={true}
                totalLabel={t("labels.checks.dashboard.inMyCountry")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Grid container justify="flex-end" alignItems="flex-end">
            {canCreate && (
              <NavLink to={"/newcheck"}>
                <CustomButton variant="primary">
                  {t("labels.checks.actions.newCheck")}
                </CustomButton>
              </NavLink>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PageHeader);
